import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";

export const YE_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['ye.IntegrationExcodaConfig', {route: '/ye/integrationExcodaConfigs'}],
            ['ye.IntegrationExcodaConfigFileProcessor', {route: '/ye/integrationExcodaConfigFileProcessors'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
